/**
 * Component gut-projects-items JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */
 
jQuery(document).ready(function () {
    const component = jQuery('.gut-projects-items');
    
    if (!component.length) {
        return;
    }

    jQuery('.gut-projects-items .gut-projects-items__carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        //
        dots: true,
        //
        arrows: true,
        prevArrow: jQuery('.gut-projects-items__top-arrows-prev a'),
        nextArrow: jQuery('.gut-projects-items__top-arrows-next a'),
        //
        infinite: true,
        autoplay: false,
        //
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
        ]
    });



});